export const EVENTS = {
  APP_WALLET_WITHDRAW: 'APP_WALLET_WITHDRAW',

  USER_LOGIN: 'USER_LOGIN',
  USER_COUNTRY_ALLOWANCE: 'USER_COUNTRY_ALLOWANCE',
  USER_ACHIEVEMENT_NEW: 'USER_ACHIEVEMENT_NEW',

  ADMIN_CONNECTED: 'GAME_ADMIN_CONNECTED',
  ADMIN_DISCONNECTED: 'GAME_ADMIN_DISCONNECTED',
  ADMIN_FIRST_MESSAGE: 'GAME_ADMIN_FIRST_MESSAGE',

  GATEWAY_CONNECTED: 'GAME_ADMIN_CONNECTED',
  GATEWAY_DISCONNECTED: 'GAME_ADMIN_DISCONNECTED',

  GAME_WON: 'GAME_WON',
  GAME_LOST: 'GAME_LOST',
  GAME_PUSHED: 'GAME_PUSHED',
  ROUND_ENDED: 'ROUND_ENDED',
  BALANCE_UPDATE: 'BALANCE_UPDATE',
  BALANCE_GATEWAY_UPDATE: 'BALANCE_GATEWAY_UPDATE',

  BID_HASH: 'BID_HASH',
  BID_CONFIRMED: 'BID_CONFIRMED',
  BID_ERROR: 'BID_ERROR',

  YLP_TOKEN_DEPOSIT: 'YLP_TOKEN_DEPOSIT',
  YLP_TOKEN_WITHDRAW: 'YLP_TOKEN_WITHDRAW',

  USERNAME_PROXY_UPDATE: 'USERNAME_PROXY_UPDATE',
  ACCOUNT_BC_CREATE: 'ACCOUNT_BC_CREATE',

  NFT_UPDATE: 'NFT_UPDATE',

  CLAIM_EARNINGS: 'CLAIM_EARNINGS',

  LVG_ORDER_PENDING: 'LVG_ORDER_PENDING',
  LVG_ORDER_PENDING_ERROR: 'LVG_ORDER_PENDING_ERROR',

  LVG_ORDER_LIVE: 'LVG_ORDER_LIVE',
  LVG_ORDER_CANCELLED: 'LVG_ORDER_CANCELLED',
  LVG_ORDER_BUSTED: 'LVG_ORDER_BUSTED',

  LVG_ORDER_CLOSING: 'LVG_ORDER_CLOSING',
  LVG_ORDER_CLOSED: 'LVG_ORDER_CLOSED',
  LVG_ORDER_CLOSING_ERROR: 'LVG_ORDER_CLOSING_ERROR',

  LVG_ORDER_UPDATING: 'LVG_ORDER_UPDATING',
  LVG_ORDER_UPDATING_ERROR: 'LVG_ORDER_UPDATING_ERROR',
}
